// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-view-container {
    padding: 24px;
    background-color: #f5f5f5;
    min-height: calc(100vh - 180px);
}

.list-view-stack {
    width: 100%;
}

.list-view-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 180px);
    padding: 24px;
}

.list-view-empty-image {
    max-width: 300px;
    margin-bottom: 24px;
}

.list-view-empty-text {
    color: #767786;
}
`, "",{"version":3,"sources":["webpack://./src/components/list/ListView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".list-view-container {\n    padding: 24px;\n    background-color: #f5f5f5;\n    min-height: calc(100vh - 180px);\n}\n\n.list-view-stack {\n    width: 100%;\n}\n\n.list-view-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: calc(100vh - 180px);\n    padding: 24px;\n}\n\n.list-view-empty-image {\n    max-width: 300px;\n    margin-bottom: 24px;\n}\n\n.list-view-empty-text {\n    color: #767786;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
